import { Language } from '@/lib/interfaces/interfaces'

// Devuelve el campo localizado `<propertyBaseName>_<language>` de una sección
// o ítem de menú (p.ej. `name_es`, `description_en`, `sectionName_ca`).
export const getTextInLanguage = (
  sectionOrItem: any,
  propertyBaseName: string,
  language: Language
): string => {
  const propertyName = `${propertyBaseName}_${language}`
  return sectionOrItem[propertyName]
}
